var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12184 23.6335H6.23114M17.7932 9.18141V4.8457M23.574 9.18141V6.29071M12.0125 9.18141V6.29071M26.4647 17.8528H30.8004M26.4647 23.6335H29.3554M26.4647 12.0721H29.3554M17.7932 26.5242V30.8599M12.0125 26.5242V29.4149M23.574 26.5242V29.4149M9.12184 17.8528H4.78613M9.12184 12.0721H6.23114",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0199 26.5254H10.5671C10.1838 26.5254 9.81629 26.3732 9.5453 26.1022C9.27431 25.8312 9.12207 25.4637 9.12207 25.0804V10.6276C9.12207 10.2444 9.27431 9.87684 9.5453 9.60585C9.81629 9.33486 10.1838 9.18262 10.5671 9.18262H25.0199C25.4031 9.18262 25.7707 9.33486 26.0417 9.60585C26.3127 9.87684 26.4649 10.2444 26.4649 10.6276V25.0804C26.4649 25.4637 26.3127 25.8312 26.0417 26.1022C25.7707 26.3732 25.4031 26.5254 25.0199 26.5254ZM20.6842 14.9633H14.9028V20.7447H20.6842V14.9633Z",
    stroke: "#212427",
    strokeWidth: 2.34282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.2bcc83d85440db823584803d07bfb6b6.svg";
export { ForwardRef as ReactComponent };